export const NEW_ACCOUNT = 'NEW ACCOUNT';
export const FETCH_ACCOUNT = 'FETCH ACCOUNT';
export const ADD_SOLDE = 'ADD SOLDE';
export const ADD_ACCESS = 'ADD ACCESS';
export const ADD_CAMPAGNE = 'ADD CAMPAGNE';
export const FETCH_CAMPAGNES = 'FETCH CAMPAGNES';
